import React from 'react';

interface UndoToastProps {
    message: string;
    secondsRemaining: number;
    onUndo: () => void;
    onClose?: () => void;
}

export default function UndoToast({ message, secondsRemaining, onUndo, onClose }: UndoToastProps) {
    return (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[120] w-[calc(100%-1.5rem)] sm:max-w-md">
            <div className="flex items-center gap-3 bg-gray-900/95 backdrop-blur px-4 py-3 rounded-lg border border-gray-700 shadow-xl">
                <div className="text-sm text-gray-200 flex-1">
                    {message} <span className="text-gray-400">({secondsRemaining}s)</span>
                </div>
                <button
                    onClick={onUndo}
                    className="text-white bg-blue-600 hover:bg-blue-500 rounded px-3 py-1 text-sm"
                >
                    Undo
                </button>
                {onClose && (
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-200 px-1"
                        aria-label="Close"
                    >
                        ×
                    </button>
                )}
            </div>
        </div>
    );
}
